import { NewsletterVariant, NewsletterWidget, notEmpty } from "@product/scmp-sdk";
import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { massageToNewsletterItem } from "~/components/content/content-newsletter-widget/helpers";
import type { widgetNewsletterArticleArticle$key } from "~/queries/__generated__/widgetNewsletterArticleArticle.graphql";

export enum Position {
  Bottom = "bottom",
  Sticky = "sticky",
}

type Props = {
  className?: string;
  isToggleSuccessMessage?: boolean;
  onSubscribeSuccess: () => void;
  position: Position;
  reference: widgetNewsletterArticleArticle$key;
};

export const NewsletterArticleWidget: FunctionComponent<Props> = ({
  className,
  isToggleSuccessMessage,
  onSubscribeSuccess,
  position,
  reference,
}) => {
  const article = useFragment(
    graphql`
      fragment widgetNewsletterArticleArticle on Article {
        relatedNewsletters {
          ...helpersMassageToNewsletterItemNewsletter
        }
      }
    `,
    reference,
  );

  const newsletterItems =
    article?.relatedNewsletters
      ?.map(newsletter => massageToNewsletterItem(newsletter))
      .filter(notEmpty) ?? [];

  const getVariant = () => {
    switch (position) {
      case Position.Bottom:
        return NewsletterVariant.NewsletterArticleBottom;
      default:
        return NewsletterVariant.NewsletterArticle;
    }
  };

  return (
    <div className={className}>
      <NewsletterWidget
        isToggleSuccessMessage={isToggleSuccessMessage}
        newsletterItems={newsletterItems}
        queryParametersForSocialButtons={{}}
        variant={getVariant()}
        onSuccess={() => {
          onSubscribeSuccess();
        }}
      />
    </div>
  );
};

NewsletterArticleWidget.displayName = "NewsletterArticleWidget";
